export interface Neighborhood {
  title: string;
  slug: string;
  districtNumber: number;
  lat: number;
  lng: number;
}

export default [
  {
    title: "Academia Militar",
    slug: "academia-militar",
    districtNumber: 1,
    lat: 12.1158,
    lng: -86.2705,
  },
  {
    title: "Acrópolis 1",
    slug: "acropolis-1",
    districtNumber: 1,
    lat: 12.0621,
    lng: -86.2785,
  },
  {
    title: "Aldo Chavarría",
    slug: "aldo-chavarria",
    districtNumber: 1,
    lat: 12.1284,
    lng: -86.2912,
  },
  {
    title: "Altamira Este",
    slug: "altamira-este",
    districtNumber: 1,
    lat: 12.1245,
    lng: -86.2558,
  },
  {
    title: "Altomonte",
    slug: "altomonte",
    districtNumber: 1,
    lat: 12.0715,
    lng: -86.2842,
  },
  {
    title: "Altos de Las Cumbres",
    slug: "altos-de-las-cumbres",
    districtNumber: 1,
    lat: 12.1025,
    lng: -86.2486,
  },
  {
    title: "Altos de Santo Domingo",
    slug: "altos-de-santo-domingo",
    districtNumber: 1,
    lat: 12.0881,
    lng: -86.2556,
  },
  {
    title: "Anexo Cruz del Paraíso",
    slug: "anexo-cruz-del-paraiso",
    districtNumber: 1,
    lat: 12.0728,
    lng: -86.2625,
  },
  {
    title: "Anexo Reparto San Juan",
    slug: "anexo-reparto-san-juan",
    districtNumber: 1,
    lat: 12.1198,
    lng: -86.2731,
  },
  {
    title: "Anexo San Juan",
    slug: "anexo-san-juan",
    districtNumber: 1,
    lat: 12.1185,
    lng: -86.2745,
  },
  {
    title: "Barrio 380",
    slug: "barrio-380",
    districtNumber: 1,
    lat: 12.1384,
    lng: -86.2741,
  },
  {
    title: "Barrio Jonathan González",
    slug: "barrio-jonathan-gonzalez",
    districtNumber: 1,
    lat: 12.1389,
    lng: -86.2789,
  },
  {
    title: "Barrio México",
    slug: "barrio-mexico",
    districtNumber: 1,
    lat: 12.1242,
    lng: -86.2494,
  },
  {
    title: "Barrio René Cisneros",
    slug: "barrio-rene-cisneros",
    districtNumber: 1,
    lat: 12.1308,
    lng: -86.2817,
  },
  {
    title: "Barrio Santos López",
    slug: "barrio-santos-lopez",
    districtNumber: 1,
    lat: 12.1402,
    lng: -86.2615,
  },
  {
    title: "Bell Air",
    slug: "bell-air",
    districtNumber: 1,
    lat: 12.1152,
    lng: -86.2631,
  },
  {
    title: "Blas Real Espinales",
    slug: "blas-real-espinales",
    districtNumber: 1,
    lat: 12.1105,
    lng: -86.2541,
  },
  {
    title: "Bolonia",
    slug: "bolonia",
    districtNumber: 1,
    lat: 12.1408,
    lng: -86.2833,
  },
  {
    title: "Bosques de Altamira",
    slug: "bosques-de-altamira",
    districtNumber: 1,
    lat: 12.1197,
    lng: -86.2542,
  },
  {
    title: "Bosques de Bolonia",
    slug: "bosques-de-bolonia",
    districtNumber: 1,
    lat: 12.1354,
    lng: -86.2872,
  },
  {
    title: "Bosques del Recreo",
    slug: "bosques-del-recreo",
    districtNumber: 1,
    lat: 12.1311,
    lng: -86.2889,
  },
  {
    title: "Buenos Aires",
    slug: "buenos-aires",
    districtNumber: 1,
    lat: 12.1147,
    lng: -86.2605,
  },
  {
    title: "Candelaria (Rubén Darío)",
    slug: "candelaria-ruben-dario",
    districtNumber: 1,
    lat: 12.1558,
    lng: -86.2642,
  },
  {
    title: "Colinas de Memorial Sandino",
    slug: "colinas-de-memorial-sandino",
    districtNumber: 1,
    lat: 12.0954,
    lng: -86.2871,
  },
  {
    title: "Colonia Edgard Lang",
    slug: "colonia-edgard-lang",
    districtNumber: 1,
    lat: 12.1347,
    lng: -86.2889,
  },
  {
    title: "Comarca Las Viudas",
    slug: "comarca-las-viudas",
    districtNumber: 1,
    lat: 12.0658,
    lng: -86.2684,
  },
  {
    title: "Edgard Munguía",
    slug: "edgard-munguia",
    districtNumber: 1,
    lat: 12.1153,
    lng: -86.2711,
  },
  {
    title: "Jorge Dimitrov",
    slug: "jorge-dimitrov",
    districtNumber: 1,
    lat: 12.134669,
    lng: -86.261794,
  },
  {
    title: "San Isidro de La Cruz Verde",
    slug: "san-isidro-de-la-cruz-verde",
    districtNumber: 1,
    lat: 12.0624,
    lng: -86.2515,
  },
  {
    title: "Santo Domingo",
    slug: "santo-domingo",
    districtNumber: 1,
    lat: 12.1017,
    lng: -86.2628,
  },
  {
    title: "Villa Fontana",
    slug: "villa-fontana",
    districtNumber: 1,
    lat: 12.1114,
    lng: -86.2717,
  },
  {
    title: "Altos de Nejapa",
    slug: "altos-de-nejapa",
    districtNumber: 1,
    lat: 12.1028,
    lng: -86.3025,
  },
  {
    title: "Candelaria",
    slug: "candelaria",
    districtNumber: 1,
    lat: 12.1555,
    lng: -86.2638,
  },
  {
    title: "Carlos Reyna",
    slug: "carlos-reyna",
    districtNumber: 1,
    lat: 12.1589,
    lng: -86.2458,
  },
  {
    title: "Catorce de Junio (La Luz)",
    slug: "catorce-de-junio-la-luz",
    districtNumber: 1,
    lat: 12.1333,
    lng: -86.2589,
  },
  {
    title: "Colonia Militar Tiscapa",
    slug: "colonia-militar-tiscapa",
    districtNumber: 1,
    lat: 12.1352,
    lng: -86.2701,
  },
  {
    title: "El Mirador",
    slug: "el-mirador",
    districtNumber: 1,
    lat: 12.0811,
    lng: -86.2417,
  },
  {
    title: "Hialeah",
    slug: "hialeah",
    districtNumber: 1,
    lat: 12.1017,
    lng: -86.2886,
  },
  {
    title: "Hialeah 4",
    slug: "hialeah-4",
    districtNumber: 1,
    lat: 12.0952,
    lng: -86.2915,
  },
  {
    title: "Jorge Domitrov",
    slug: "jorge-domitrov",
    districtNumber: 1,
    lat: 12.1365,
    lng: -86.2621,
  },
  {
    title: "La Esperanza",
    slug: "la-esperanza",
    districtNumber: 1,
    lat: 12.1117,
    lng: -86.3056,
  },
  {
    title: "Miguel Bonijja (Zogaib)",
    slug: "miguel-bonijja-zogaib",
    districtNumber: 1,
    lat: 12.1053,
    lng: -86.2658,
  },
  {
    title: "Rene Cisneros",
    slug: "rene-cisneros",
    districtNumber: 1,
    lat: 12.1305,
    lng: -86.2815,
  },
  {
    title: "Sector Norte Comarca Las Viudas",
    slug: "sector-norte-comarca-las-viudas",
    districtNumber: 1,
    lat: 12.0722,
    lng: -86.2691,
  },
  {
    title: "Sector Sur Comarca Silvia Ferrufino",
    slug: "sector-sur-comarca-silvia-ferrufino",
    districtNumber: 1,
    lat: 12.1525,
    lng: -86.2115,
  },
  {
    title: "Villa Italianas",
    slug: "villa-italianas",
    districtNumber: 1,
    lat: 12.0989,
    lng: -86.2583,
  },
  {
    title: "Motastepe",
    slug: "motastepe",
    districtNumber: 2,
    lat: 12.1328,
    lng: -86.3264,
  },
  {
    title: "Jardines de Managua",
    slug: "jardines-de-managua",
    districtNumber: 2,
    lat: 12.1461,
    lng: -86.2975,
  },
  {
    title: "Las Palmas",
    slug: "las-palmas",
    districtNumber: 2,
    lat: 12.1481,
    lng: -86.2881,
  },
  {
    title: "Colonia Mántica",
    slug: "colonia-mantica",
    districtNumber: 2,
    lat: 12.1444,
    lng: -86.2861,
  },
  {
    title: "El Carmen",
    slug: "el-carmen",
    districtNumber: 2,
    lat: 12.1411,
    lng: -86.2794,
  },
  {
    title: "Linda Vista Sur",
    slug: "linda-vista-sur",
    districtNumber: 2,
    lat: 12.1503,
    lng: -86.3056,
  },
  {
    title: "Los Arcos",
    slug: "los-arcos",
    districtNumber: 2,
    lat: 12.1528,
    lng: -86.3089,
  },
  {
    title: "Loma Verde (El Seminario)",
    slug: "loma-verde-el-seminario",
    districtNumber: 2,
    lat: 12.1386,
    lng: -86.3103,
  },
  {
    title: "Valle Dorado",
    slug: "valle-dorado",
    districtNumber: 2,
    lat: 12.1469,
    lng: -86.3142,
  },
  {
    title: "Las Brisas",
    slug: "las-brisas",
    districtNumber: 2,
    lat: 12.1564,
    lng: -86.3117,
  },
  {
    title: "Linda Vista Norte",
    slug: "linda-vista-norte",
    districtNumber: 2,
    lat: 12.1542,
    lng: -86.3039,
  },
  {
    title: "Miraflores",
    slug: "miraflores",
    districtNumber: 2,
    lat: 12.1511,
    lng: -86.2961,
  },
  {
    title: "El Cortijo",
    slug: "el-cortijo",
    districtNumber: 2,
    lat: 12.1633,
    lng: -86.3156,
  },
  {
    title: "Cristo del Rosario",
    slug: "cristo-del-rosario",
    districtNumber: 2,
    lat: 12.1611,
    lng: -86.2856,
  },
  {
    title: "San Sebastián",
    slug: "san-sebastian",
    districtNumber: 2,
    lat: 12.1594,
    lng: -86.2764,
  },
  {
    title: "La Cruz",
    slug: "la-cruz",
    districtNumber: 2,
    lat: 12.1597,
    lng: -86.2656,
  },
  {
    title: "Santa Ana Norte y Sur",
    slug: "santa-ana-norte-y-sur",
    districtNumber: 2,
    lat: 12.1561,
    lng: -86.2889,
  },
  {
    title: "Monseñor Lezcano",
    slug: "monsenor-lezcano",
    districtNumber: 2,
    lat: 12.1508,
    lng: -86.2931,
  },
  {
    title: "Javier Cuadra",
    slug: "javier-cuadra",
    districtNumber: 2,
    lat: 12.1514,
    lng: -86.2833,
  },
  {
    title: "Acahualinca",
    slug: "acahualinca",
    districtNumber: 2,
    lat: 12.1647,
    lng: -86.2947,
  },
  {
    title: "Barrio Cuba (Rubén Darío)",
    slug: "barrio-cuba-ruben-dario",
    districtNumber: 2,
    lat: 12.1581,
    lng: -86.2936,
  },
  {
    title: "Martha Quezada",
    slug: "martha-quezada",
    districtNumber: 2,
    lat: 12.1464,
    lng: -86.2769,
  },
  {
    title: "Francisco Morazán",
    slug: "francisco-morazan",
    districtNumber: 2,
    lat: 12.1417,
    lng: -86.3044,
  },
  {
    title: "San Antonio",
    slug: "san-antonio",
    districtNumber: 2,
    lat: 12.1542,
    lng: -86.2736,
  },
  {
    title: "Llamas del Bosque",
    slug: "llamas-del-bosque",
    districtNumber: 2,
    lat: 12.1389,
    lng: -86.2997,
  },
  {
    title: "Batahola Norte",
    slug: "batahola-norte",
    districtNumber: 2,
    lat: 12.1436,
    lng: -86.2958,
  },
  {
    title: "Complejo Minusválido",
    slug: "complejo-minusvalido",
    districtNumber: 2,
    lat: 12.1367,
    lng: -86.2933,
  },
  {
    title: "Rafael Ríos",
    slug: "rafael-rios",
    districtNumber: 2,
    lat: 12.1583,
    lng: -86.3025,
  },
  {
    title: "Reparto España",
    slug: "reparto-espana",
    districtNumber: 2,
    lat: 12.1489,
    lng: -86.3114,
  },
  {
    title: "Carlos Ulloa",
    slug: "carlos-ulloa",
    districtNumber: 2,
    lat: 12.1622,
    lng: -86.3083,
  },
  {
    title: "Oscar Robelo 1 y 2",
    slug: "oscar-robelo-1-y-2",
    districtNumber: 2,
    lat: 12.1661,
    lng: -86.3106,
  },
  {
    title: "Francisco y Ramón Sánchez",
    slug: "francisco-y-ramon-sanchez",
    districtNumber: 2,
    lat: 12.1653,
    lng: -86.3047,
  },
  {
    title: "Alfredo Silva",
    slug: "alfredo-silva",
    districtNumber: 2,
    lat: 12.1575,
    lng: -86.2803,
  },
  {
    title: "Alemania Democrática",
    slug: "alemania-democratica",
    districtNumber: 2,
    lat: 12.1628,
    lng: -86.3028,
  },
  {
    title: "18 de Mayo",
    slug: "18-de-mayo",
    districtNumber: 2,
    lat: 12.1194,
    lng: -86.2417,
  },
  {
    title: "Julio Buitrago Norte y Sur",
    slug: "julio-buitrago-norte-y-sur",
    districtNumber: 2,
    lat: 12.1517,
    lng: -86.2797,
  },
  {
    title: "Dignidad 4 de Mayo",
    slug: "dignidad-4-de-mayo",
    districtNumber: 2,
    lat: 12.1483,
    lng: -86.2717,
  },
  {
    title: "Manuel Olivares",
    slug: "manuel-olivares",
    districtNumber: 2,
    lat: 12.1458,
    lng: -86.3081,
  },
  {
    title: "Edgar Lang",
    slug: "edgar-lang",
    districtNumber: 2,
    lat: 12.1347,
    lng: -86.2889,
  },
  {
    title: "Batahola Sur",
    slug: "batahola-sur",
    districtNumber: 2,
    lat: 12.130508,
    lng: -86.306465,
  },
  {
    title: "San Pedro",
    slug: "san-pedro",
    districtNumber: 2,
    lat: 12.1553,
    lng: -86.2694,
  },
  {
    title: "Bella Vista",
    slug: "bella-vista",
    districtNumber: 2,
    lat: 12.1589,
    lng: -86.3117,
  },
  {
    title: "Cienfuegos",
    slug: "cienfuegos",
    districtNumber: 2,
    lat: 12.1644,
    lng: -86.3189,
  },
  {
    title: "El Rastro",
    slug: "el-rastro",
    districtNumber: 2,
    lat: 12.1667,
    lng: -86.2883,
  },
  {
    title: "Ferrocarril",
    slug: "ferrocarril",
    districtNumber: 2,
    lat: 12.1603,
    lng: -86.2628,
  },
  {
    title: "Gadala María",
    slug: "gadala-maria",
    districtNumber: 2,
    lat: 12.1614,
    lng: -86.3006,
  },
  {
    title: "La Chureca",
    slug: "la-chureca",
    districtNumber: 2,
    lat: 12.1703,
    lng: -86.3086,
  },
  {
    title: "El Boer",
    slug: "el-boer",
    districtNumber: 2,
    lat: 12.1517,
    lng: -86.2667,
  },
  {
    title: "Los Madroños",
    slug: "los-madronos",
    districtNumber: 2,
    lat: 12.1453,
    lng: -86.3014,
  },
  {
    title: "Juan E. Menocal",
    slug: "juan-e-menocal",
    districtNumber: 2,
    lat: 12.1556,
    lng: -86.3153,
  },
  {
    title: "Daniel Chavarría",
    slug: "daniel-chavarria",
    districtNumber: 2,
    lat: 12.1597,
    lng: -86.3069,
  },
  {
    title: "Célfida Miranda",
    slug: "celfida-miranda",
    districtNumber: 2,
    lat: 12.1678,
    lng: -86.3011,
  },
  {
    title: "Modesto Bejarano",
    slug: "modesto-bejarano",
    districtNumber: 2,
    lat: 12.1694,
    lng: -86.2972,
  },
  {
    title: "Damnificados Huracán Jhon",
    slug: "damnificados-huracan-jhon",
    districtNumber: 2,
    lat: 12.1708,
    lng: -86.2939,
  },
  {
    title: "William Díaz",
    slug: "william-diaz",
    districtNumber: 2,
    lat: 12.1489,
    lng: -86.2744,
  },
  {
    title: "Dinamarca",
    slug: "dinamarca",
    districtNumber: 2,
    lat: 12.1536,
    lng: -86.3183,
  },
  {
    title: "Manchester",
    slug: "manchester",
    districtNumber: 2,
    lat: 12.1544,
    lng: -86.2811,
  },
  {
    title: "Correo Central",
    slug: "correo-central",
    districtNumber: 2,
    lat: 12.1567,
    lng: -86.2644,
  },
  {
    title: "San José Boer",
    slug: "san-jose-boer",
    districtNumber: 2,
    lat: 12.1506,
    lng: -86.2683,
  },
  {
    title: "Residencial San Sebastian",
    slug: "residencial-san-sebastian",
    districtNumber: 2,
    lat: 12.106194,
    lng: -86.205633,
  },
  {
    title: "Los Robles",
    slug: "los-robles",
    districtNumber: 3,
    lat: 12.1258,
    lng: -86.2655,
  },
  {
    title: "Planes de Altamira",
    slug: "planes-de-altamira",
    districtNumber: 3,
    lat: 12.1195,
    lng: -86.2608,
  },
  {
    title: "Bellair 8",
    slug: "bellair-8",
    districtNumber: 3,
    lat: 12.1152,
    lng: -86.2631,
  },
  {
    title: "Marcell Pallais",
    slug: "marcell-pallais",
    districtNumber: 3,
    lat: 12.1106,
    lng: -86.2642,
  },
  {
    title: "Planetarium",
    slug: "planetarium",
    districtNumber: 3,
    lat: 12.1189,
    lng: -86.2814,
  },
  {
    title: "Belmonte",
    slug: "belmonte",
    districtNumber: 3,
    lat: 12.1311,
    lng: -86.3117,
  },
  {
    title: "Bolonia y Bosques de Bolonia",
    slug: "bolonia-y-bosques-de-bolonia",
    districtNumber: 3,
    lat: 12.1408,
    lng: -86.2833,
  },
  {
    title: "Lomas de Montserrat",
    slug: "lomas-de-montserrat",
    districtNumber: 3,
    lat: 12.1022,
    lng: -86.2731,
  },
  {
    title: "Tiscapa",
    slug: "tiscapa",
    districtNumber: 3,
    lat: 12.1386,
    lng: -86.2711,
  },
  {
    title: "Lomas de Guadalupe",
    slug: "lomas-de-guadalupe",
    districtNumber: 3,
    lat: 12.111633,
    lng: -86.197512,
  },
  {
    title: "Reparto San Juan",
    slug: "reparto-san-juan",
    districtNumber: 3,
    lat: 12.1214,
    lng: -86.2719,
  },
  {
    title: "Reisel",
    slug: "reisel",
    districtNumber: 3,
    lat: 12.1281,
    lng: -86.3089,
  },
  {
    title: "Frawley",
    slug: "frawley",
    districtNumber: 3,
    lat: 12.1239,
    lng: -86.3131,
  },
  {
    title: "San Patricio",
    slug: "san-patricio",
    districtNumber: 3,
    lat: 12.1086,
    lng: -86.3197,
  },
  {
    title: "San Martín",
    slug: "san-martin",
    districtNumber: 3,
    lat: 12.1164,
    lng: -86.3103,
  },
  {
    title: "Las Flores (La Cañada)",
    slug: "las-flores-la-canada",
    districtNumber: 3,
    lat: 12.0944,
    lng: -86.3217,
  },
  {
    title: "Héroes y Mártires de Bocay",
    slug: "heroes-y-martires-de-bocay",
    districtNumber: 3,
    lat: 12.1319,
    lng: -86.3167,
  },
  {
    title: "Santa Fe",
    slug: "santa-fe",
    districtNumber: 3,
    lat: 12.1128,
    lng: -86.3144,
  },
  {
    title: "Lomas de San Juan",
    slug: "lomas-de-san-juan",
    districtNumber: 3,
    lat: 12.1181,
    lng: -86.2764,
  },
  {
    title: "Reparto San Angel",
    slug: "reparto-san-angel",
    districtNumber: 3,
    lat: 12.1158,
    lng: -86.2797,
  },
  {
    title: "Casa Fontana",
    slug: "casa-fontana",
    districtNumber: 3,
    lat: 12.1064,
    lng: -86.2783,
  },
  {
    title: "Lomas del Sur",
    slug: "lomas-del-sur",
    districtNumber: 3,
    lat: 12.0886,
    lng: -86.2847,
  },
  {
    title: "Lomas de Ticomo",
    slug: "lomas-de-ticomo",
    districtNumber: 3,
    lat: 12.0917,
    lng: -86.3314,
  },
  {
    title: "Altagracia",
    slug: "altagracia",
    districtNumber: 3,
    lat: 12.1417,
    lng: -86.2953,
  },
  {
    title: "San Pablo",
    slug: "san-pablo",
    districtNumber: 3,
    lat: 12.1039,
    lng: -86.3086,
  },
  {
    title: "Andrés Castro",
    slug: "andres-castro",
    districtNumber: 3,
    lat: 12.1353,
    lng: -86.2997,
  },
  {
    title: "El Pilar Norte",
    slug: "el-pilar-norte",
    districtNumber: 3,
    lat: 12.1183,
    lng: -86.3022,
  },
  {
    title: "Helena",
    slug: "helena",
    districtNumber: 3,
    lat: 12.1119,
    lng: -86.3253,
  },
  {
    title: "Vista Hermosa",
    slug: "vista-hermosa",
    districtNumber: 3,
    lat: 12.1278,
    lng: -86.3164,
  },
  {
    title: "Camilo Ortega",
    slug: "camilo-ortega",
    districtNumber: 3,
    lat: 12.1089,
    lng: -86.3286,
  },
  {
    title: "El Pilar",
    slug: "el-pilar",
    districtNumber: 3,
    lat: 12.1156,
    lng: -86.3022,
  },
  {
    title: "San Judas",
    slug: "san-judas",
    districtNumber: 3,
    lat: 12.1114,
    lng: -86.2961,
  },
  {
    title: "Sierra Maestra Norte y Sur",
    slug: "sierra-maestra-norte-y-sur",
    districtNumber: 3,
    lat: 12.0942,
    lng: -86.2953,
  },
  {
    title: "El Recreo No. 1 y 2",
    slug: "el-recreo-no-1-y-2",
    districtNumber: 3,
    lat: 12.1331,
    lng: -86.2889,
  },
  {
    title: "Villa Roma",
    slug: "villa-roma",
    districtNumber: 3,
    lat: 12.1014,
    lng: -86.3006,
  },
  {
    title: "Miguel Bonilla (Zogaib)",
    slug: "miguel-bonilla-zogaib",
    districtNumber: 3,
    lat: 12.1053,
    lng: -86.2658,
  },
  {
    title: "Colonia El Periodista",
    slug: "colonia-el-periodista",
    districtNumber: 3,
    lat: 12.1264,
    lng: -86.2861,
  },
  {
    title: "Mirna Ugarte",
    slug: "mirna-ugarte",
    districtNumber: 3,
    lat: 12.1344,
    lng: -86.3108,
  },
  {
    title: "Recreo Sur",
    slug: "recreo-sur",
    districtNumber: 3,
    lat: 12.1286,
    lng: -86.2889,
  },
  {
    title: "Enrique Schmit",
    slug: "enrique-schmit",
    districtNumber: 3,
    lat: 12.1067,
    lng: -86.2606,
  },
  {
    title: "Nora Astorga",
    slug: "nora-astorga",
    districtNumber: 3,
    lat: 12.1325,
    lng: -86.3033,
  },
  {
    title: "Waslala (San Ignacio)",
    slug: "waslala-san-ignacio",
    districtNumber: 3,
    lat: 12.0978,
    lng: -86.3167,
  },
  {
    title: "25 Aniversario",
    slug: "25-aniversario",
    districtNumber: 3,
    lat: 12.1003,
    lng: -86.3225,
  },
  {
    title: "Bertha Calderón (El Prado)",
    slug: "bertha-calderon-el-prado",
    districtNumber: 3,
    lat: 12.1247,
    lng: -86.2936,
  },
  {
    title: "Leonel Rugama",
    slug: "leonel-rugama",
    districtNumber: 3,
    lat: 12.0911,
    lng: -86.3056,
  },
  {
    title: "Jonathan González (Bolonia No. 2)",
    slug: "jonathan-gonzalez-bolonia-no-2",
    districtNumber: 3,
    lat: 12.1389,
    lng: -86.2789,
  },
  {
    title: "Edgar Munguía",
    slug: "edgar-munguia",
    districtNumber: 3,
    lat: 12.1153,
    lng: -86.2711,
  },
  {
    title: "Germán Pomares (Ticomo/Nejapa)",
    slug: "german-pomares",
    districtNumber: 3,
    lat: 12.0967,
    lng: -86.3311,
  },
  {
    title: "Martín Luther King",
    slug: "martin-luther-king",
    districtNumber: 3,
    lat: 12.1044,
    lng: -86.2858,
  },
  {
    title: "Marvin Marín",
    slug: "marvin-marin",
    districtNumber: 3,
    lat: 12.0925,
    lng: -86.3139,
  },
  {
    title: "Luis Alfonso Velázquez",
    slug: "luis-alfonso-velazquez",
    districtNumber: 3,
    lat: 12.1481,
    lng: -86.2708,
  },
  {
    title: "La Esperanza No. 1 y 2",
    slug: "la-esperanza-no-1-y-2",
    districtNumber: 3,
    lat: 12.1117,
    lng: -86.3056,
  },
  {
    title: "Carlos Calero",
    slug: "carlos-calero",
    districtNumber: 3,
    lat: 12.1083,
    lng: -86.3022,
  },
  {
    title: "Héroes y Mártires de Ayapal",
    slug: "heroes-y-martires-de-ayapal",
    districtNumber: 3,
    lat: 12.1242,
    lng: -86.3208,
  },
  {
    title: "David Tejada",
    slug: "david-tejada",
    districtNumber: 3,
    lat: 12.1206,
    lng: -86.3167,
  },
  {
    title: "El Pantanal",
    slug: "el-pantanal",
    districtNumber: 3,
    lat: 12.1056,
    lng: -86.3353,
  },
  {
    title: "Carlos Nuñez",
    slug: "carlos-nunez",
    districtNumber: 3,
    lat: 12.1289,
    lng: -86.3267,
  },
  {
    title: "Leonardo García Jara",
    slug: "leonardo-garcia-jara",
    districtNumber: 3,
    lat: 12.1136,
    lng: -86.3214,
  },
  {
    title: "Reparto Plaza España",
    slug: "reparto-plaza-espana",
    districtNumber: 3,
    lat: 12.1339,
    lng: -86.2806,
  },
  {
    title: "Golfo Pérsico",
    slug: "golfo-persico",
    districtNumber: 3,
    lat: 12.0983,
    lng: -86.2917,
  },
  {
    title: "Enrique Bermúdez (3-80)",
    slug: "enrique-bermudez-3-80",
    districtNumber: 3,
    lat: 12.1025,
    lng: -86.3283,
  },
  {
    title: "Villa Argentina",
    slug: "villa-argentina",
    districtNumber: 3,
    lat: 12.1281,
    lng: -86.2742,
  },
  {
    title: "Aquiles Morales",
    slug: "aquiles-morales",
    districtNumber: 3,
    lat: 12.1042,
    lng: -86.3167,
  },
  {
    title: "Memorial Sandino",
    slug: "memorial-sandino",
    districtNumber: 3,
    lat: 12.0914,
    lng: -86.2883,
  },
  {
    title: "Casimiro Sotelo",
    slug: "casimiro-sotelo",
    districtNumber: 3,
    lat: 12.1186,
    lng: -86.2683,
  },
  {
    title: "Tierra Prometida",
    slug: "tierra-prometida",
    districtNumber: 3,
    lat: 12.1203,
    lng: -86.3289,
  },
  {
    title: "Sierra Maestra",
    slug: "sierra-maestra",
    districtNumber: 3,
    lat: 12.0942,
    lng: -86.2953,
  },
  {
    title: "Chiquilistagua",
    slug: "chiquilistagua",
    districtNumber: 3,
    lat: 12.0789,
    lng: -86.3458,
  },
  {
    title: "Cedro Galán",
    slug: "cedro-galan",
    districtNumber: 3,
    lat: 12.0736,
    lng: -86.3364,
  },
  {
    title: "Monte Tabor",
    slug: "monte-tabor",
    districtNumber: 3,
    lat: 12.0833,
    lng: -86.3267,
  },
  {
    title: "Largaespada",
    slug: "largaespada",
    districtNumber: 4,
    lat: 12.1408,
    lng: -86.2656,
  },
  {
    title: "Serrano",
    slug: "serrano",
    districtNumber: 4,
    lat: 12.1433,
    lng: -86.2611,
  },
  {
    title: "San Lucas (La Aviación)",
    slug: "san-lucas-la-aviacion",
    districtNumber: 4,
    lat: 12.1528,
    lng: -86.2417,
  },
  {
    title: "Jardines de Santa Clara",
    slug: "jardines-de-santa-clara",
    districtNumber: 4,
    lat: 12.1558,
    lng: -86.2294,
  },
  {
    title: "Santa Clara",
    slug: "santa-clara",
    districtNumber: 4,
    lat: 12.156563,
    lng: -86.233828,
  },
  {
    title: "Ciudad Jardín",
    slug: "ciudad-jardin",
    districtNumber: 4,
    lat: 12.1467,
    lng: -86.2553,
  },
  {
    title: "Bello Horizonte",
    slug: "bello-horizonte",
    districtNumber: 4,
    lat: 12.145719,
    lng: -86.232653
  },
  {
    title: "Campo Bruce",
    slug: "campo-bruce",
    districtNumber: 4,
    lat: 12.1358,
    lng: -86.2575,
  },
  {
    title: "Sajonia",
    slug: "sajonia",
    districtNumber: 4,
    lat: 12.1489,
    lng: -86.2619,
  },
  {
    title: "San José Oriental",
    slug: "san-jose-oriental",
    districtNumber: 4,
    lat: 12.1411,
    lng: -86.2497,
  },
  {
    title: "Los Angeles",
    slug: "los-angeles",
    districtNumber: 4,
    lat: 12.1494,
    lng: -86.2525,
  },
  {
    title: "Riguero Norte",
    slug: "riguero-norte",
    districtNumber: 4,
    lat: 12.153242,
    lng: -86.235623,
  },
  {
    title: "Domitila Lugo",
    slug: "domitila-lugo",
    districtNumber: 4,
    lat: 12.1633,
    lng: -86.2367,
  },
  {
    title: "Selim Schible (El Tempisque)",
    slug: "selim-schible",
    districtNumber: 4,
    lat: 12.153610, 
    lng: -86.226593,
  },
  {
    title: "Carlos Reyna (Quinta Nina)",
    slug: "carlos-reyna-quinta-nina",
    districtNumber: 4,
    lat: 12.1589,
    lng: -86.2458,
  },
  {
    title: "San Luis Norte y Sur",
    slug: "san-luis-norte-y-sur",
    districtNumber: 4,
    lat: 12.1536,
    lng: -86.2486,
  },
  {
    title: "Villa Venezuela",
    slug: "villa-venezuela",
    districtNumber: 4,
    lat: 12.125758,
    lng: -86.213067,
  },
  {
    title: "Villa Flor Norte",
    slug: "villa-flor-norte",
    districtNumber: 4,
    lat: 12.123289,
    lng: -86.219997,
  },
  {
    title: "Parrales Vallejos",
    slug: "parrales-vallejos",
    districtNumber: 4,
    lat: 12.1517,
    lng: -86.2239,
  },
  {
    title: "Ducualí",
    slug: "ducuali",
    districtNumber: 4,
    lat: 12.1364,
    lng: -86.2425,
  },
  {
    title: "Santa Rosa",
    slug: "santa-rosa",
    districtNumber: 4,
    lat: 12.1522,
    lng: -86.2319,
  },
  {
    title: "Primero de Mayo",
    slug: "primero-de-mayo",
    districtNumber: 4,
    lat: 12.125810,
    lng: -86.221443,
  },
  {
    title: "San Cristóbal",
    slug: "san-cristobal",
    districtNumber: 4,
    lat: 12.1328,
    lng: -86.2456,
  },
  {
    title: "María Auxiliadora",
    slug: "maria-auxiliadora",
    districtNumber: 4,
    lat: 12.1408,
    lng: -86.2414,
  },
  {
    title: "El Paraisito",
    slug: "el-paraisito",
    districtNumber: 4,
    lat: 12.1447,
    lng: -86.2511,
  },
  {
    title: "Larreynaga",
    slug: "larreynaga",
    districtNumber: 4,
    lat: 12.1461,
    lng: -86.2447,
  },
  {
    title: "Costa Rica",
    slug: "costa-rica",
    districtNumber: 4,
    lat: 12.1511,
    lng: -86.2389,
  },
  {
    title: "El Edén",
    slug: "el-eden",
    districtNumber: 4,
    lat: 12.1469,
    lng: -86.2478,
  },
  {
    title: "Pedro Joaquín Chamorro",
    slug: "pedro-joaquin-chamorro",
    districtNumber: 4,
    lat: 12.1614,
    lng: -86.2497,
  },
  {
    title: "Colonia Managua",
    slug: "colonia-managua",
    districtNumber: 4,
    lat: 12.1553,
    lng: -86.2436,
  },
  {
    title: "Maestro Gabriel",
    slug: "maestro-gabriel",
    districtNumber: 4,
    lat: 12.1483,
    lng: -86.2417,
  },
  {
    title: "Christian Pérez",
    slug: "christian-perez",
    districtNumber: 4,
    lat: 12.1506,
    lng: -86.2514,
  },
  {
    title: "La Tenderí",
    slug: "la-tenderi",
    districtNumber: 4,
    lat: 12.1458,
    lng: -86.2519,
  },
  {
    title: "Hilario Sánchez",
    slug: "hilario-sanchez",
    districtNumber: 4,
    lat: 12.1656,
    lng: -86.2311,
  },
  {
    title: "Jorge Dimitrov (Cristo Rey)",
    slug: "jorge-dimitrov-cristo-rey",
    districtNumber: 4,
    lat: 12.1361,
    lng: -86.2619,
  },
  {
    title: "Nueva Libia",
    slug: "nueva-libia",
    districtNumber: 4,
    lat: 12.1389,
    lng: -86.2356,
  },
  {
    title: "Unión Soviética",
    slug: "union-sovietica",
    districtNumber: 4,
    lat: 12.135433,
    lng: -86.231821,
  },
  {
    title: "Paula Corea",
    slug: "paula-corea",
    districtNumber: 4,
    lat: 12.1286,
    lng: -86.2442,
  },
  {
    title: "Lomas de Santo Domingo",
    slug: "lomas-de-santo-domingo",
    districtNumber: 5,
    lat: 12.0945,
    lng: -86.2528,
  },
  {
    title: "Las Praderas",
    slug: "las-praderas",
    districtNumber: 5,
    lat: 12.0912,
    lng: -86.2444,
  },
  {
    title: "Jardín de Las Colinas",
    slug: "jardin-de-las-colinas",
    districtNumber: 5,
    lat: 12.0839,
    lng: -86.2297,
  },
  {
    title: "Los Palmares",
    slug: "los-palmares",
    districtNumber: 5,
    lat: 12.0864,
    lng: -86.2231,
  },
  {
    title: "Santa Mónica",
    slug: "santa-monica",
    districtNumber: 5,
    lat: 12.0967,
    lng: -86.2389,
  },
  {
    title: "Las Colinas",
    slug: "las-colinas",
    districtNumber: 5,
    lat: 12.0894,
    lng: -86.2286,
  },
  {
    title: "Lomas de Las Colinas",
    slug: "lomas-de-las-colinas",
    districtNumber: 5,
    lat: 12.0853,
    lng: -86.2314,
  },
  {
    title: "La Colina",
    slug: "la-colina",
    districtNumber: 5,
    lat: 12.0872,
    lng: -86.2253,
  },
  {
    title: "Estancia Santo Domingo",
    slug: "estancia-santo-domingo",
    districtNumber: 5,
    lat: 12.0928,
    lng: -86.2589,
  },
  {
    title: "Intermeso del Bosque",
    slug: "intermeso-del-bosque",
    districtNumber: 5,
    lat: 12.0711,
    lng: -86.2656,
  },
  {
    title: "Colonial Los Robles",
    slug: "colonial-los-robles",
    districtNumber: 5,
    lat: 12.1225,
    lng: -86.2581,
  },
  {
    title: "Altamira y Bosques de Altamira",
    slug: "altamira-y-bosques-de-altamira",
    districtNumber: 5,
    lat: 12.1197,
    lng: -86.2542,
  },
  {
    title: "Jardines de Veracruz",
    slug: "jardines-de-veracruz",
    districtNumber: 5,
    lat: 12.120470,
    lng: -86.229624
  },
  {
    title: "El Dorado",
    slug: "el-dorado",
    districtNumber: 5,
    lat: 12.1311,
    lng: -86.2436,
  },
  {
    title: "La Alameda",
    slug: "la-alameda",
    districtNumber: 5,
    lat: 12.1283,
    lng: -86.2497,
  },
  {
    title: "Lomas del Valle",
    slug: "lomas-del-valle",
    districtNumber: 5,
    lat: 12.1064,
    lng: -86.2447,
  },
  {
    title: "Las Cumbres",
    slug: "las-cumbres",
    districtNumber: 5,
    lat: 12.1014,
    lng: -86.2525,
  },
  {
    title: "Villas Italianas",
    slug: "villas-italianas",
    districtNumber: 5,
    lat: 12.0989,
    lng: -86.2583,
  },
  {
    title: "Villa Fontana Este",
    slug: "villa-fontana-este",
    districtNumber: 5,
    lat: 12.1086,
    lng: -86.2647,
  },
  {
    title: "Bosques de Santa María",
    slug: "bosques-de-santa-maria",
    districtNumber: 5,
    lat: 12.0656,
    lng: -86.2189,
  },
  {
    title: "Sócrates Sandino",
    slug: "socrates-sandino",
    districtNumber: 5,
    lat: 12.1033,
    lng: -86.2311,
  },
  {
    title: "Blanca Segovia (Barilocho)",
    slug: "blanca-segovia-barilocho",
    districtNumber: 5,
    lat: 12.1011,
    lng: -86.2367,
  },
  {
    title: "Cuba Libre",
    slug: "cuba-libre",
    districtNumber: 5,
    lat: 12.1047,
    lng: -86.2386,
  },
  {
    title: "Salomón Moreno (Open No. 2)",
    slug: "salomon-moreno-open-no-2",
    districtNumber: 5,
    lat: 12.1019,
    lng: -86.2239,
  },
  {
    title: "René Schick (Macaralay/Valentino)",
    slug: "rene-schick",
    districtNumber: 5,
    lat: 12.1067,
    lng: -86.2289,
  },
  {
    title: "Eduardo Contreras (Santa Elisa)",
    slug: "eduardo-contreras-santa-elisa",
    districtNumber: 5,
    lat: 12.1114,
    lng: -86.2389,
  },
  {
    title: "La Fuente (Ariel Darce)",
    slug: "la-fuente-ariel-darce",
    districtNumber: 5,
    lat: 12.1136,
    lng: -86.2428,
  },
  {
    title: "Adolfo Reyes (Reparto Urbina)",
    slug: "adolfo-reyes-reparto-urbina",
    districtNumber: 5,
    lat: 12.1203,
    lng: -86.2467,
  },
  {
    title: "México",
    slug: "mexico",
    districtNumber: 5,
    lat: 12.1242,
    lng: -86.2494,
  },
  {
    title: "Liberia",
    slug: "liberia",
    districtNumber: 5,
    lat: 12.1172,
    lng: -86.2411,
  },
  {
    title: "La Luz (14 de Junio)",
    slug: "la-luz-14-de-junio",
    districtNumber: 5,
    lat: 12.1333,
    lng: -86.2589,
  },
  {
    title: "Riguero",
    slug: "riguero",
    districtNumber: 5,
    lat: 12.1294,
    lng: -86.2536,
  },
  {
    title: "Santa Barbara",
    slug: "santa-barbara",
    districtNumber: 5,
    lat: 12.1147,
    lng: -86.2217,
  },
  {
    title: "Santa Emilia",
    slug: "santa-emilia",
    districtNumber: 5,
    lat: 12.1169,
    lng: -86.2264,
  },
  {
    title: "Colonia Centro América",
    slug: "colonia-centro-america",
    districtNumber: 5,
    lat: 12.1114,
    lng: -86.2514,
  },
  {
    title: "Máximo Jerez",
    slug: "maximo-jerez",
    districtNumber: 5,
    lat: 12.1231,
    lng: -86.2597,
  },
  {
    title: "Nicarao",
    slug: "nicarao",
    districtNumber: 5,
    lat: 12.1181,
    lng: -86.2361,
  },
  {
    title: "14 de Septiembre",
    slug: "14-de-septiembre",
    districtNumber: 5,
    lat: 12.1139,
    lng: -86.2325,
  },
  {
    title: "10 de Junio",
    slug: "10-de-junio",
    districtNumber: 5,
    lat: 12.1197,
    lng: -86.2453,
  },
  {
    title: "Colonia Don Bosco",
    slug: "colonia-don-bosco",
    districtNumber: 5,
    lat: 12.1281,
    lng: -86.2389,
  },
  {
    title: "José Isaías Gómez",
    slug: "jose-isaias-gomez",
    districtNumber: 5,
    lat: 12.1317,
    lng: -86.2564,
  },
  {
    title: "Villa Finlandia",
    slug: "villa-finlandia",
    districtNumber: 5,
    lat: 12.1092,
    lng: -86.2136,
  },
  {
    title: "Alfredo Nobel",
    slug: "alfredo-nobel",
    districtNumber: 5,
    lat: 12.1156,
    lng: -86.2183,
  },
  {
    title: "Georgino Andrade",
    slug: "georgino-andrade",
    districtNumber: 5,
    lat: 12.1206,
    lng: -86.2211,
  },
  {
    title: "Walter Ferrety 1 y 2",
    slug: "walter-ferrety-1-y-2",
    districtNumber: 5,
    lat: 12.0964,
    lng: -86.2197,
  },
  {
    title: "Grenada",
    slug: "grenada",
    districtNumber: 5,
    lat: 12.118226,
    lng: -86.244997,
  },
  {
    title: "22 de Enero (La Cascada)",
    slug: "22-de-enero-la-cascada",
    districtNumber: 5,
    lat: 12.0886,
    lng: -86.2131,
  },
  {
    title: "Villa Amor",
    slug: "villa-amor",
    districtNumber: 5,
    lat: 12.1036,
    lng: -86.2089,
  },
  {
    title: "28 de Mayo",
    slug: "28-de-mayo",
    districtNumber: 5,
    lat: 12.1058,
    lng: -86.2056,
  },
  {
    title: "Omar Torrijos",
    slug: "omar-torrijos",
    districtNumber: 5,
    lat: 12.1022,
    lng: -86.2194,
  },
  {
    title: "Farabundo Martí",
    slug: "farabundo-marti",
    districtNumber: 5,
    lat: 12.1083,
    lng: -86.2239,
  },
  {
    title: "Nicaragua Libre",
    slug: "nicaragua-libre",
    districtNumber: 5,
    lat: 12.1103,
    lng: -86.2211,
  },
  {
    title: "Pablo Úbeda",
    slug: "pablo-ubeda",
    districtNumber: 5,
    lat: 12.1042,
    lng: -86.2217,
  },
  {
    title: "Milagro de Dios",
    slug: "milagro-de-dios",
    districtNumber: 5,
    lat: 12.113412,
    lng: -86.217496,
  },
  {
    title: "Residencial Milagro de Dios",
    slug: "residencial-milagro-de-dios",
    districtNumber: 5,
    lat: 12.114618,
    lng: -86.213679,
  },
  {
    title: "Esquipulas",
    slug: "esquipulas",
    districtNumber: 5,
    lat: 12.0628,
    lng: -86.2144,
  },
  {
    title: "Las Jaguitas",
    slug: "las-jaguitas",
    districtNumber: 5,
    lat: 12.0783,
    lng: -86.1961,
  },
  {
    title: "San Antonio Sur",
    slug: "san-antonio-sur",
    districtNumber: 5,
    lat: 12.0556,
    lng: -86.2417,
  },
  {
    title: "Jocote Dulce",
    slug: "jocote-dulce",
    districtNumber: 5,
    lat: 12.0689,
    lng: -86.2736,
  },
  { title: "19 de Febrero", slug: "19-de-febrero", districtNumber: 6, lat: 12.1485, lng: -86.2052 },
  { title: "Anexo La Primavera", slug: "anexo-la-primavera", districtNumber: 6, lat: 12.1642, lng: -86.2165 },
  { title: "B-15", slug: "b-15", districtNumber: 6, lat: 12.1412, lng: -86.1985 },
  { title: "Bertha Díaz", slug: "bertha-diaz", districtNumber: 6, lat: 12.1528, lng: -86.1953 },
  { title: "Camilo Chamorro 4", slug: "camilo-chamorro", districtNumber: 6, lat: 12.153870, lng: -86.197208 },
  { title: "Carlos Marx", slug: "carlos-marx", districtNumber: 6, lat: 12.1384, lng: -86.2241 },
  { title: "Ciudad Belén 1", slug: "ciudad-belen-1", districtNumber: 6, lat: 12.1383, lng: -86.1508 },
  { title: "Ciudad Belén 2", slug: "ciudad-belen-2", districtNumber: 6, lat: 12.1405, lng: -86.1485 },
  { title: "Colinas de Verona", slug: "colinas-de-verona", districtNumber: 6, lat: 12.1258, lng: -86.1524 },
  { title: "José Dolores Estrada", slug: "jose-dolores-estrada", districtNumber: 6, lat: 12.152811, lng: -86.211540 },
  { title: "Jorge Cassaly Estrada", slug: "jorge-cassaly-estrada", districtNumber: 6, lat: 12.1539, lng: -86.1889 },
  { title: "La Primavera", slug: "la-primavera", districtNumber: 6, lat: 12.153016, lng: -86.219206 },
  { title: "Los Rieles de Abajo", slug: "los-rieles-de-abajo", districtNumber: 6, lat: 12.1582, lng: -86.1754 },
  { title: "Los Sabogales", slug: "los-sabogales", districtNumber: 6, lat: 12.1456, lng: -86.1821 },
  { title: "Miguel Gutiérrez", slug: "miguel-gutierrez", districtNumber: 6, lat: 12.142612, lng: -86.213076 },
  { title: "Oswaldo Manzanares", slug: "oswaldo-manzanares", districtNumber: 6, lat: 12.1415, lng: -86.2198 },
  { title: "Santa Elena", slug: "santa-elena", districtNumber: 6, lat: 12.1558, lng: -86.1653 },
  { title: "Sector La Kativo", slug: "sector-la-kativo", districtNumber: 6, lat: 12.1512, lng: -86.2085 },
  { title: "Unidad de Propósito", slug: "unidad-de-proposito", districtNumber: 6, lat: 12.1411, lng: -86.1736 },
  { title: "Villa Feliz", slug: "villa-feliz", districtNumber: 6, lat: 12.1285, lng: -86.1824 },
  { title: "Villa José Benito A1, 2B, C", slug: "villa-jose-benito-a1-2b-c", districtNumber: 6, lat: 12.1428, lng: -86.1917 },
  { title: "Villa José Benito D, E, F", slug: "villa-jose-benito-d-e-f", districtNumber: 6, lat: 12.1445, lng: -86.1885 },
  { title: "Villa Progreso", slug: "villa-progreso", districtNumber: 6, lat: 12.1389, lng: -86.2167 },
  { title: "Waspan Norte", slug: "waspan-norte", districtNumber: 6, lat: 12.1622, lng: -86.2086 },
  { title: "Waspan Sur", slug: "waspan-sur", districtNumber: 6, lat: 12.1556, lng: -86.2053 },
  { title: "Reparto Simón Bolívar", slug: "reparto-simon-bolivar", districtNumber: 6, lat: 12.132389, lng: -86.195580 },
  { title: "Colonia Rubén Darío", slug: "colonia-ruben-dario", districtNumber: 6, lat: 12.140063, lng: -86.220250 },
  { title: "Residencial Villa Flor de Pino", slug: "residencial-villa-flor-de-pino", districtNumber: 6, lat: 12.156608, lng: -86.164281 },
  { title: "Colonia Xolotlán", slug: "colonia-xolotlan", districtNumber: 6, lat: 12.145209, lng: -86.219509 },
  { title: "Barrio Mombacho", slug: "barrio-mombacho", districtNumber: 6, lat: 12.147953, lng: -86.215865 },
  { title: "Praderas del doral", slug: "praderas-del-doral", districtNumber: 6, lat: 12.129082, lng: -86.188946 },
  { title: "Sabana Grande", slug: "sabana-grande", districtNumber: 7, lat: 12.123332, lng: -86.169447 },
  { title: "Urbanizacion altos de la sabana", slug: "altos-de-la-sabana", districtNumber: 7, lat: 12.124310, lng: -86.180443 },
  { title: "Laureles Norte", slug: "laureles-norte", districtNumber: 7, lat: 12.129175, lng: -86.197639 },
  { title: "Américas 3", slug: "americas-3", districtNumber: 7, lat: 12.129784, lng: -86.212494 },
  { title: "Américas 2", slug: "americas-2", districtNumber: 7, lat: 12.160435, lng: -86.190034 },
  { title: "Américas 1", slug: "americas-1", districtNumber: 7, lat: 12.133737, lng: -86.219576 },
  { title: "Villa Libertad", slug: "villa-libertad", districtNumber: 7, lat: 12.115506, lng: -86.201461 },
  { title: "Anexo Villa Libertad", slug: "anexo-villa-libertad", districtNumber: 7, lat: 12.116694, lng: -86.207901 },
] as Neighborhood[];
